import { connect } from 'react-redux'
import Expired from './expired'
import { resendMagicLink } from '../../redux/magic-links.actions'
import { getSendAnotherRequest } from '../../redux/magic-links.selectors'
import { withRouter } from 'react-router'

const mapStateToProps = state => ({
  pending: getSendAnotherRequest(state).pending
})

const mapDispatchToProps = (dispatch, { match }) => ({
  onResend: () => dispatch(resendMagicLink(match.params.token))
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Expired)
)
